import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const tomes = [{
  number: '01',
  title: 'Gestión Técnico-Administrativa y Legal',
  desc: 'Blindaje legal, documentación, informes para Obras Sociales, honorarios y marco administrativo completo.'
}, {
  number: '02',
  title: 'Evaluación Clínica y Diagnóstico Cinético-Funcional',
  desc: 'Anamnesis, tests, goniometría, fuerza, banderas rojas y razonamiento clínico listo para aplicar.'
}, {
  number: '03',
  title: 'Protocolos en Traumatología y Ortopedia',
  desc: 'Patologías frecuentes y protocolos terapéuticos por fases listos para usar desde hoy.'
}, {
  number: '04',
  title: 'Abordaje Kinésico en Internación Domiciliaria',
  desc: 'Paciente domiciliario, geriatría, neurología, respiratorio, familia y seguridad del kinesiólogo.'
}, {
  number: '05',
  title: 'Neurociencia Aplicada a la Educación del Paciente',
  desc: 'Dolor, educación terapéutica, adherencia y comunicación clínica basada en evidencia.'
}, {
  number: '06',
  title: 'Gestión de Carrera y Práctica Independiente',
  desc: 'Monotributo, marca profesional, agenda, honorarios y estrategia de crecimiento profesional.'
}];
const includes = ['Protocolos listos para usar desde hoy', 'Plantillas de informes para Obras Sociales', 'Checklists de evaluación y seguimiento clínico', 'Documentación legal y consentimientos informados', 'Scripts de comunicación con pacientes', 'Planificación de sesiones por objetivo y fase'];
export function WhatYouGet() {
  useTrackSection('what-you-get', 'What You Get Section');
  return <section id="what-you-get" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(235,248,255) 0%, rgb(224,247,255) 15%, rgb(224,247,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-355">
      <div className="mx-auto max-w-4xl" data-id="element-356">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-357">
          Lo que{' '}
          <span style={{
          color: '#0077B6'
        }} data-id="element-358">
            recibís
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-359">
          6 tomos · +350 páginas · Todo listo para implementar hoy
        </p>

        {/* Tomos */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-6" style={{
        border: '1px solid rgba(0,119,182,0.20)'
      }} data-id="element-360">
          {/* Header */}
          <div className="px-5 py-3" style={{
          backgroundColor: '#0077B6'
        }} data-id="element-361">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-362">
              🦴 LOS 6 TOMOS — Sistema Clínico Completo para Kinesiólogos
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-363">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-364">
                {/* Número */}
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(0,119,182,0.30)'
            }} data-id="element-365">
                  {tome.number}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-366">
                  <span className="block text-sm font-black text-gray-900" data-id="element-367">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-368">
                    {tome.desc}
                  </span>
                </div>

                {/* Páginas */}
                <span className="shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5" style={{
              color: '#0077B6',
              backgroundColor: 'rgba(0,119,182,0.05)',
              border: '1px solid rgba(0,119,182,0.20)'
            }} data-id="element-369">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(0,119,182,0.20)'
      }} data-id="element-370">
          {/* Header */}
          <div className="px-5 py-3" style={{
          backgroundColor: 'rgba(0,119,182,0.05)',
          borderBottom: '1px solid rgba(0,119,182,0.20)'
        }} data-id="element-371">
            <h3 className="text-sm font-black m-0" style={{
            color: '#0077B6'
          }} data-id="element-372">
              Cada tomo incluye:
            </h3>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-373">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-374">
                <span className="shrink-0 font-bold text-sm mt-0.5" style={{
              color: '#0077B6'
            }} data-id="element-375">
                  ✅
                </span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-376">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}